import { getTodayISO, getDaysAgoISO } from "../utils";

const DATE_PRESETS = [
  { label: "All Time", from: null, to: null },
  { label: "Today", from: getTodayISO(), to: getTodayISO() },
  { label: "Yesterday", from: getDaysAgoISO(1), to: getDaysAgoISO(1) },
  { label: "Last 7 Days", from: getDaysAgoISO(7), to: null },
  { label: "Last 30 Days", from: getDaysAgoISO(30), to: null },
];

export default function DateFilter({ fromDate, toDate, onChange, filteredCount }) {
  const isActive = fromDate || toDate;

  return (
    <div className="date-filter">
      <div className="filter-presets">
        {DATE_PRESETS.map((preset) => (
          <button
            key={preset.label}
            className={`preset-btn ${
              !fromDate && !toDate && !preset.from
                ? "active"
                : fromDate === preset.from && toDate === preset.to
                  ? "active"
                  : ""
            }`}
            onClick={() => onChange(preset.from, preset.to)}
          >
            {preset.label}
          </button>
        ))}
      </div>
      <div className="filter-custom">
        <label>
          From:
          <input
            type="date"
            value={fromDate || ""}
            onChange={(e) => onChange(e.target.value || null, toDate)}
          />
        </label>
        <label>
          To:
          <input
            type="date"
            value={toDate || ""}
            onChange={(e) => onChange(fromDate, e.target.value || null)}
          />
        </label>
        {isActive && (
          <button className="clear-btn" onClick={() => onChange(null, null)}>
            Clear
          </button>
        )}
      </div>
      {isActive && filteredCount !== undefined && (
        <div className="filter-info">
          Showing data from <strong>{filteredCount}</strong> images
        </div>
      )}
    </div>
  );
}
